import { render, staticRenderFns } from "./WeakCurrentBoxScene.vue?vue&type=template&id=741ce214&scoped=true"
import script from "./WeakCurrentBoxScene.vue?vue&type=script&lang=js"
export * from "./WeakCurrentBoxScene.vue?vue&type=script&lang=js"
import style0 from "./WeakCurrentBoxScene.vue?vue&type=style&index=0&id=741ce214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ce214",
  null
  
)

export default component.exports